window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

window.params = function (obj) {
    return Object.keys(obj).map(function (key) {
        return key + '=' + obj[key];
    }).join('&');
};

window.nl2br = function (str) {
    if (typeof str === 'undefined' || str === null) {
        return '';
    }
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}

window.ufirst = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

window.scrollLock = function (lock) {
    if (lock) {
        document.querySelector('html').style.overflow = 'hidden';
    } else {
        document.querySelector('html').style.overflow = '';
    }
}